import { useMemo } from 'react'
import {
  INVENTORY_CHANNEL_B2B,
  INVENTORY_CHANNEL_B2C,
} from 'lib/inventoryStates'
import {
  ROLE_ADMIN,
  ROLE_B2C,
  ROLE_PARTNER_ADMIN,
  ROLE_SUPER_ADMIN,
  useAuth,
} from 'auth'
import config from 'config'

import { INVENTORY_ACTIONS_MAP_STATE } from './inventoryLib'

const useInventoryActions = ({ selected = [] } = { selected: [] }) => {
  const { hasOneOfRoles } = useAuth()

  const sixtAdmin = useMemo(() => hasOneOfRoles(ROLE_ADMIN), [hasOneOfRoles])
  const isSuperAdmin = useMemo(
    () => hasOneOfRoles(ROLE_SUPER_ADMIN),
    [hasOneOfRoles]
  )
  const partnerAdmin = useMemo(
    () => hasOneOfRoles([ROLE_PARTNER_ADMIN]),
    [hasOneOfRoles]
  )

  const b2c = useMemo(() => hasOneOfRoles([ROLE_B2C]), [hasOneOfRoles])

  const actionEnabledStructure = INVENTORY_ACTIONS_MAP_STATE[config.country]

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const actionItemsEnabled = useMemo(() => {
    const enabled = {}
    Object.keys(actionEnabledStructure).forEach((action) => {
      const {
        checkPartnerAdmin,
        checkSixtAdmin,
        checkSuperAdmin,
        checkB2C,
        checkChannelB2C,
        checkHistoryCount,
        inventoryAllowedTransitions,
        inventoryRemoveTransitionsB2B,
        inventoryNotAllowedTransitions,
        inventoryAllowedRepairTransitions,
        inventoryNotAllowedRepairTransitions,
      } = actionEnabledStructure[action]

      enabled[action] =
        ((checkPartnerAdmin && partnerAdmin) ||
          (checkSixtAdmin && sixtAdmin) ||
          (checkSuperAdmin && isSuperAdmin) ||
          (checkB2C && b2c)) &&
        selected.every((car) => {
          const allowedTransitions = inventoryAllowedTransitions
          const removeTransitions =
            car.channel === INVENTORY_CHANNEL_B2B
              ? inventoryRemoveTransitionsB2B || []
              : []

          if (removeTransitions.includes(car.state)) return false

          return (
            (!inventoryNotAllowedTransitions ||
              inventoryNotAllowedTransitions.length === 0 ||
              !inventoryNotAllowedTransitions.includes(car.state)) &&
            (!allowedTransitions ||
              allowedTransitions.length === 0 ||
              allowedTransitions.includes(car.state)) &&
            (!inventoryNotAllowedRepairTransitions ||
              inventoryNotAllowedRepairTransitions.length === 0 ||
              !inventoryNotAllowedRepairTransitions.includes(
                car.repairState
              )) &&
            (!inventoryAllowedRepairTransitions ||
              inventoryAllowedRepairTransitions.length === 0 ||
              inventoryAllowedRepairTransitions.includes(car.repairState)) &&
            (!checkChannelB2C || car.channel === INVENTORY_CHANNEL_B2C) &&
            (!checkHistoryCount || car.historyCount > 0)
          )
        })
    })
    return enabled
  }, [
    actionEnabledStructure,
    b2c,
    isSuperAdmin,
    partnerAdmin,
    selected,
    sixtAdmin,
  ])

  return {
    actionItemsEnabled,
  }
}

export default useInventoryActions
